// import React, { useState, useEffect } from "react";
// import { FaRegUserCircle } from "react-icons/fa";
// import { NavLink, useNavigate } from "react-router-dom";
// import axios from "axios";
// import apiKey from "../../../config/apiKey";

// function UnreadNotification() {
//   const [notifications, setNotifications] = useState([]);
//   const teacher = JSON.parse(localStorage.getItem("edo-teacher"));
//   const userId = teacher ? teacher.teacher.id : "";
//   const [loading, setLoading] = useState(true); // Add loading state
//   useEffect(() => {
//     const fetchNotifications = async () => {
// //setIsLoading(true);; // Start loading before data fetch
//       try {
//         const response = await axios.get(`${apiKey}/api/edolutions/teacher/notifications/unread/${userId}`, {
//           headers: {
//             Authorization: `Bearer ${teacher?.token}`,
//           },
//         });
//         setNotifications(response.data);
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//       finally {
//         setLoading(false); // Stop loading after data fetch
//       }
//     };

//     fetchNotifications();
//   }, [userId,teacher?.token]);

//   const markAsRead = async (notificationId) => {
//     try {
//       await axios.put(`${apiKey}/api/edolutions/teacher/notifications/mark-as-read/${notificationId}`, {}, {
//         headers: {
//           Authorization: `Bearer ${teacher?.token}`,
//         },
//       });
//       setNotifications((prevNotifications) =>
//         prevNotifications.map((notification) =>
//           notification.id === notificationId ? { ...notification, read: true } : notification
//         )
//       );
//     } catch (error) {
//       console.error("Error marking notification as read:", error);
//     }
//   };



//   const markAsDecline = async (notificationId) => {
//     try {
//       await axios.put(`${apiKey}/api/edolutions/teacher/notifications/mark-as-decline/${notificationId}`, {}, {
//         headers: {
//           Authorization: `Bearer ${teacher?.token}`,
//         },
//       });
//       setNotifications((prevNotifications) =>
//         prevNotifications.map((notification) =>
//           notification.id === notificationId ? { ...notification, decline: 1 } : notification
//         )
//       );
//     } catch (error) {
//       console.error("Error marking notification as read:", error);
//     }
//   };

//   const navigate = useNavigate();

//   const handleAccept = (id, typeId) => {
//     markAsRead(id);
//     if (typeId === 1) {
//       navigate('/teacher/homeTution');
//     } else if (typeId === 2) {
//       navigate('/mentor/mysessions');
//     }
//   };

//   return (
//     <div className="flex items-center xl:p-5 sm:p-0 justify-center">
//       <div className="w-full border rounded-3xl shadow-xl p-5">
//         <div>
//           <p className="text-2xl font-bold">Notifications</p>
//         </div>
//         <div className="flex border-b-2 justify-between items-center mt-8">
//           <div className="flex flex-wrap md:justify-start md:space-x-12 space-x-5 text-base font-medium">
//             <NavLink
//               to=".././notification"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B]"
//                   : undefined
//               }
//             >
//               All
//             </NavLink>

//             {/* <NavLink
//               to=".././newNotification"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-blue-500 border-b-2 border-blue-500"
//                   : undefined
//               }
//             >
//               New
//             </NavLink> */}

//             <NavLink
//               to=".././unreadNotification"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B]"
//                   : undefined
//               }
//             >
//               Unread
//             </NavLink>
//           </div>
//           <div>
//             {/* <p
//               className="text-[12px] bg-[#FAFAF8] text-[#7E7E7E] font-semibold border-[#7E7E7E] p-1 rounded-lg cursor-pointer mb-2"
//               onClick={markAllAsRead}
//             >
//               Mark All As Read
//             </p> */}
//           </div>
//         </div>
//         {loading ? (
//                     <tr>
//                       <td colSpan="9" className="py-5 px-1 text-center">
//                         <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
//                           <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#EE5F2B]"></div>
//                           <p className="mt-4 text-lg font-semibold text-[#EE5F2B]">
//                             Cabil...
//                           </p>
//                         </div>
//                       </td>
//                     </tr>
//                   ) : notifications.length === 0 ? (
//                     <tr>
//                       <td colSpan="9" className="py-5 px-1 text-center">
//                         <p className="text-gray-500">No Unread Notification Available</p>
//                       </td>
//                     </tr>
//                   ) : (
//         notifications.map((notification) => (
//           <div
//             key={notification.id}
//             className="grid grid-cols-2 gap-4 my-4 bg-[#A3E7E11C] p-4"
//           >
//             <div className="flex gap-2">
//               <div>
//                 <FaRegUserCircle className="h-8 w-8" />
//               </div>
//               <div>
//                 <p className="text-[#2D3748] capitalize text-[14px] font-semibold">
//                   {notification.message}
//                 </p>
//                 <span className="text-[12px] text-[#2D3748]">
//                   {new Date(notification.created_at).toLocaleString()}
//                 </span>
//               </div>
//             </div>

//              <div className="text-end">
//                 {/* {console.log("Notification:", notification)} */}
//                 {!notification.read && notification.decline !== 1 && (
//                   <button
//                   className="border rounded-sm text-[12px] text-[#828282] px-5 py-1 font-semibold bg-[#E1E1E1] m-2"
//                   onClick={() => handleAccept(notification.id, notification.type_id)}
//                 >
//                   Accept
//                 </button>
//                 )}

//                 {!notification.read && notification.decline !== 1 && (
//                   <button
//                     className="border rounded-sm text-[12px] text-[#828282] px-5 py-1 font-semibold bg-[#E1E1E1] m-2"
//                     onClick={() => markAsDecline(notification.id)}
//                   >
//                     Decline
//                   </button>
//                 )}
//                 {notification.read === 1 && notification.decline !== 1 && (
//                   <button
//                     className="border rounded-sm text-[12px] px-5 py-1 font-semibold bg-[#4FD1C5] text-white m-2"
//                     disabled
//                   >
//                     Accepted
//                   </button>
//                 )}
//                 {notification.decline === 1 && (
//                   <button
//                     className="border rounded-sm text-[12px] px-5 py-1 font-semibold bg-red-500 text-white m-2"
//                     disabled
//                   >
//                     Declined
//                   </button>
//                 )}
//               </div>
//           </div>
//         )))}
//       </div>
//     </div>
//   );
// }

// export default UnreadNotification;

import React, { useState, useEffect } from "react";
import { FaRegUserCircle } from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import apiKey from "../../../config/apiKey";
import { useTranslation } from "react-i18next";

const UnreadNotification = () => {
  const { t } = useTranslation();
  /* -------------------- PRESENTATION HELPERS (UI ONLY) -------------------- */
  const Page = ({ children }) => (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#FFF4EE] via-white to-[#E8F7F5]">
      <div className="mx-auto max-w-6xl px-4 py-8">{children}</div>
    </div>
  );

  const StickyHeader = () => (
    <div className="sticky top-0 z-10 -mx-4 mb-6 border-b border-[#F0F2F7] bg-white/80 backdrop-blur supports-[backdrop-filter]:backdrop-blur px-4 py-4">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <div>
          <h1 className="text-2xl md:text-3xl font-black tracking-tight text-[#2A3A54]">
            {t("teacherDash.notification.unreadTitle")}
          </h1>
          <p className="text-xs text-gray-500">{t("teacherDash.notification.unreadSubtitle")}</p>
        </div>
        <div className="flex items-center gap-6 text-sm font-semibold">
          <NavLink
            to=".././notification"
            className={({ isActive }) =>
              isActive
                ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B] pb-2"
                : "text-gray-600 hover:text-[#2A3A54] pb-2"
            }
          >
            {t("teacherDash.notification.tabAll")}
          </NavLink>
          <NavLink
            to=".././unreadNotification"
            className={({ isActive }) =>
              isActive
                ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B] pb-2"
                : "text-gray-600 hover:text-[#2A3A54] pb-2"
            }
          >
            {t("teacherDash.notification.tabUnread")}
          </NavLink>
        </div>
      </div>
    </div>
  );

  const SideCard = ({ title, children }) => (
    <div className="rounded-2xl border border-[#E9EDF3] bg-white shadow-sm p-5">
      <h3 className="text-base font-bold text-[#2A3A54]">{title}</h3>
      <div className="mt-3">{children}</div>
    </div>
  );

  const Pill = ({ children, tone = "default" }) => {
    const tones = {
      default: "bg-gray-100 text-gray-700",
      new: "bg-[#FFF1EB] text-[#b5471e]",
      accepted: "bg-[#E8FFFB] text-[#0F766E]",
      declined: "bg-red-100 text-red-700",
    };
    return (
      <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold ${tones[tone]}`}>
        {children}
      </span>
    );
  };

  const Kbd = ({ children }) => (
    <kbd className="rounded-md border border-gray-300 bg-gray-50 px-1.5 py-0.5 text-[10px] text-gray-600">
      {children}
    </kbd>
  );

  const Action = ({ children, variant = "ghost", ...props }) => {
    const base = "rounded-lg px-3.5 py-2 text-[12px] font-semibold transition";
    const styles = {
      ghost: "bg-gray-100 text-gray-700 hover:bg-gray-200",
      accept: "bg-[#10BFA8] text-white hover:brightness-95",
      decline: "bg-red-500 text-white hover:brightness-95",
    };
    return (
      <button className={`${base} ${styles[variant]}`} {...props}>
        {children}
      </button>
    );
  };

  const TimelineItem = ({ n, onAccept, onDecline }) => (
    <div className="group relative pl-10">
      {/* line */}
      <div className="absolute left-[14px] top-0 bottom-0 w-[2px] bg-gradient-to-b from-[#E2E8F0] to-transparent" />
      {/* dot */}
      <div className="absolute left-2 top-2 h-4 w-4 rounded-full ring-4 ring-white bg-[#2A3A54]" />

      <div className="rounded-xl border border-[#E9EDF3] bg-white/90 shadow-sm backdrop-blur p-4 hover:shadow-md transition">
        <div className="flex items-start gap-3">
          <div className="shrink-0">
            <FaRegUserCircle className="h-10 w-10 text-[#2A3A54]" />
          </div>
          <div className="flex-1">
            <p className="text-[14px] font-semibold text-[#2D3748] capitalize">
              {n.message}
            </p>

            <div className="mt-1 flex flex-wrap items-center gap-2">
              <span className="text-[12px] text-gray-500">
                {new Date(n.created_at).toLocaleString()}
              </span>
              {!n.read && n.decline !== 1 && <Pill tone="new">{t("teacherDash.notification.badgeNew")}</Pill>}
              {n.read === 1 && n.decline !== 1 && <Pill tone="accepted">{t("teacherDash.notification.accepted")}</Pill>}
              {n.decline === 1 && <Pill tone="declined">{t("teacherDash.notification.declined")}</Pill>}
            </div>

            <div className="mt-3 flex flex-wrap gap-2">
              {!n.read && n.decline !== 1 && (
                <>
                  <Action onClick={() => onAccept(n.id, n.type_id)} variant="ghost">
                    {t("teacherDash.common.accept")}
                  </Action>
                  <Action onClick={() => onDecline(n.id)} variant="ghost">
                    {t("teacherDash.notification.decline")}
                  </Action>
                </>
              )}
              {/* {n.read === 1 && n.decline !== 1 && (
                <Action variant="accept" disabled>
                  Accepted
                </Action>
              )}
              {n.decline === 1 && (
                <Action variant="decline" disabled>
                  Declined
                </Action>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const Skeleton = () => (
    <div className="space-y-6">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="relative pl-10">
          <div className="absolute left-[14px] top-0 bottom-0 w-[2px] bg-gradient-to-b from-[#E2E8F0] to-transparent" />
          <div className="absolute left-2 top-2 h-4 w-4 rounded-full ring-4 ring-white bg-gray-300" />
          <div className="animate-pulse rounded-xl border border-[#E9EDF3] bg-white p-4">
            <div className="flex items-start gap-3">
              <div className="h-10 w-10 rounded-full bg-gray-200" />
              <div className="flex-1 space-y-2">
                <div className="h-4 w-2/3 bg-gray-200 rounded" />
                <div className="h-3 w-40 bg-gray-200 rounded" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  const Empty = () => (
    <div className="rounded-2xl border border-dashed border-[#E9EDF3] bg-white/70 p-10 text-center">
      <p className="text-gray-500">{t("teacherDash.notification.noUnreadNotifications")}</p>
    </div>
  );

  /* ------------------------------ EXISTING LOGIC ------------------------------ */
  const [notifications, setNotifications] = useState([]);
  const teacher = JSON.parse(localStorage.getItem("edo-teacher"));
  const userId = teacher ? teacher.teacher.id : "";
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axios.get(
          `${apiKey}/api/edolutions/teacher/notifications/unread/${userId}`,
          { headers: { Authorization: `Bearer ${teacher?.token}` } }
        );
        setNotifications(response.data);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, [userId, teacher?.token]);

  const markAsRead = async (notificationId) => {
    try {
      await axios.put(
        `${apiKey}/api/edolutions/teacher/notifications/mark-as-read/${notificationId}`,
        {},
        { headers: { Authorization: `Bearer ${teacher?.token}` } }
      );
      setNotifications((prev) =>
        prev.map((n) => (n.id === notificationId ? { ...n, read: true } : n))
      );
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const markAsDecline = async (notificationId) => {
    try {
      await axios.put(
        `${apiKey}/api/edolutions/teacher/notifications/mark-as-decline/${notificationId}`,
        {},
        { headers: { Authorization: `Bearer ${teacher?.token}` } }
      );
      setNotifications((prev) =>
        prev.map((n) => (n.id === notificationId ? { ...n, decline: 1 } : n))
      );
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const handleAccept = (id, typeId) => {
    markAsRead(id);
    if (typeId === 1) navigate("/mentor/home-tution");
    else if (typeId === 2) navigate("/mentor/my-sessions");
  };

  /* ---------------------------------- RENDER --------------------------------- */
  return (
    <Page>
      <StickyHeader />
      <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">
        {/* Timeline column */}
        <div className="space-y-6">
          {loading ? (
            <Skeleton />
          ) : notifications.length === 0 ? (
            <Empty />
          ) : (
            notifications.map((n) => (
              <TimelineItem
                key={n.id}
                n={n}
                onAccept={handleAccept}
                onDecline={markAsDecline}
              />
            ))
          )}
        </div>

        {/* Right sidebar */}
        {/* <div className="space-y-6">
          <SideCard title="Shortcuts">
            <div className="flex flex-wrap gap-2 text-sm">
              <div className="rounded-lg bg-[#FFF1EB] text-[#B5471E] px-3 py-1.5">All</div>
              <div className="rounded-lg bg-[#E8FFFB] text-[#0F766E] px-3 py-1.5">Accepted</div>
              <div className="rounded-lg bg-red-50 text-red-700 px-3 py-1.5">Declined</div>
            </div>
          </SideCard>

          <SideCard title="Tips">
            <ul className="list-disc pl-5 text-sm text-gray-600 space-y-2">
              <li>Press <Kbd>A</Kbd> to accept quickly</li>
              <li>Press <Kbd>D</Kbd> to decline</li>
              <li>Navigate between tabs to filter</li>
            </ul>
          </SideCard>
        </div> */}
      </div>
    </Page>
  );
};

export default UnreadNotification;

